<template>
    <div class="container">
        <!-- 操作区域 -->
        <el-card class="operation-card">
            <div class="flex-container">
                <!-- <el-input v-model="token" placeholder="令牌值" style="width: 200px"></el-input> -->
                <el-input type="textarea" v-model="accountIds" :rows="1" placeholder="请输入批搭指令中的关键词"
                    style="width: 300px; margin: 0 20px"></el-input>
                <el-button type="primary" @click="handleQuery" :loading="queryLoading">查询</el-button>


            </div>
        </el-card>

        <!-- 数据表格 -->
        <el-card class="data-card">
            <el-table :data="tableData" v-loading="loading" border @selection-change="handleSelectionChange"
                style="width: 100%" @sort-change="handleSortChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="idsname" label="账户uuid"></el-table-column>
                <el-table-column prop="groupId" label="广告组id"></el-table-column>
                <el-table-column prop="advertisementId" label="广告id"></el-table-column>
                <el-table-column prop="id" label="创意id"></el-table-column>
                <!-- <el-table-column prop="yestConsume" label="展现形式"></el-table-column> -->
                <el-table-column prop="createDate" label="创建时间" :formatter="formatDate"></el-table-column>
                <el-table-column prop="auditState" label="广告收拢状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.auditState == 2" style="color:green">审核通过</span>
                        <!-- <span v-else-if="scope.row.auditState == 1" style="color:orange">待审核</span>
                        <span v-else style="color:red">审核不通过</span> -->
                    </template>
                </el-table-column>
                <el-table-column prop="statusDesc" label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="GetPlan(scope.$index, scope.row)">
                            查看素材详情
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
        </el-card>
        <el-dialog title="素材详情" :visible.sync="plsucaidialogVisible" width="900px" class="custom-dialog">
            <div>

            </div>
            <div style="display: flex;">
                <div style="display: flex;align-items: center;margin-right: 30px;">头像： </div>
                <div style="width: 350px;height:350px;"><el-image :src="ruleForm[0].avatarFullUrl"
                        v-if="ruleForm[0].avatarFullUrl"></el-image>
                    <div v-else>无</div>
                </div>
            </div>
            <div style="display: flex;">
                <div style="display: flex;align-items: center;margin-right: 30px;">素材图片： </div>
                <div style="width: 450px;height:450px;"><el-image :src="ruleForm[0].imgsFullUrl"
                        v-if="ruleForm[0].imgsFullUrl"></el-image>
                    <div v-else>无</div>
                </div>
            </div>
            <div style="display: flex;">
                <div style="display: flex;align-items: center;margin-right: 30px;">素材视频： </div>
                <div><video controls v-if="ruleForm[0].videoFullUrl">
                        <source :src="ruleForm[0].videoFullUrl" type="video/mp4">
                        <source :src="ruleForm[0].videoFullUrl" type="video/ogg">
                        您的浏览器不支持 video 标签。
                    </video>
                    <div v-else>无</div>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <!-- <el-button @click="clonehandSelects()">取 消</el-button> -->
            </div>
        </el-dialog>
    </div>
</template>

<script>

import axios from "axios";
export default {
    data() {
        // 自定义验证规则
        const validateNumber = (rule, value, callback) => {
            if (value === "" || value === null) {
                callback(new Error("请输入数字"));
            } else if (value <= 0) {
                callback(new Error("数字必须大于0"));
            } else {
                callback();
            }
        };
        return {
            loading: false,
            plsucaidialogVisible: false,
            token: '',
            accountIds: '',
            amount: 0,
            tableData: [],
            sortProp: '',
            sortOrder: '',
            selectedData: [], // 选中的数据
            queryLoading: false, // 查询加载状态
            dialogVisible: false,
            form: {
                number: null
            },
            rules: {
                number: [
                    { required: true, validator: validateNumber, trigger: "blur" }
                ]
            },
            ruleForm: [
                {
                    avatarFullUrl: 'your-image-url.jpg'
                }
                // 其他行数据...
            ],
        }
    },
    methods: {
        async GetPlan(id, row) {
            this.ruleForm = [row]
            this.plsucaidialogVisible = true
            console.log(row);
        },
        formatDate(row, column, cellValue) {
            const date = new Date(cellValue);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        openDialog() {
            this.dialogVisible = true;
        },
        handleConfirm() {
            this.$refs.numberForm.validate(valid => {
                if (valid) {
                    console.log("输入的数字是：", this.form.number);

                    this.TransformAll()

                }
            });
        },
        resetForm() {
            this.$refs.numberForm.resetFields();
        },
        //转出所有
        async TransformAll() {
            const accounts = this.selectedData;

            const requests = accounts.map(user => {
                return (async () => {
                    let currentAmount = user.cashBalance;
                    const MAX_RETRIES = 20;
                    let attempts = 0;

                    while (attempts++ < MAX_RETRIES) {
                        try {
                            // 发送请求并获取响应
                            const res = await this.sendTransferRequest({
                                accountId: user.uuid,
                                amount: currentAmount,
                                type: "OUT",
                                token: this.token
                            });

                            // 检查响应中的业务错误
                            if (res.data.message === "转出金额大于当前账户余额") {
                                // 手动抛出错误触发 catch
                                throw new Error("INSUFFICIENT_BALANCE");
                            }

                            // 成功时直接返回
                            return res;
                        } catch (error) {
                            // 处理特定业务错误
                            if (error.message === "INSUFFICIENT_BALANCE" ||
                                (error.response.data.message === "转出金额大于当前账户余额")) {
                                currentAmount -= this.form.number;

                                // 金额耗尽处理
                                if (currentAmount <= 0) {
                                    throw new Error(`账户 ${user.uuid} 转出失败：可用金额不足`);
                                }

                                // 添加延迟防止高频请求（可选）
                                await new Promise(resolve => setTimeout(resolve, 50));
                                continue;
                            }

                            // 其他错误直接抛出
                            throw error;
                        }
                    }
                    throw new Error(`账户 ${user.uuid} 超过最大重试次数`);
                })();
            });

            try {
                await Promise.all(requests);
                this.dialogVisible = false;
                this.$message.success('操作成功');
                this.handleQuery();
            } catch (error) {
                this.$message.error(error.message || '部分操作失败');
            }
        },
        handleSelectionChange(selection) {
            this.selectedData = selection; // 将选中的数据保存到 selectedData
            console.log('选中的数据:', selection);
        },
        async handleQuery() {
            if (!this.accountIds) return;

            this.queryLoading = true;
            this.tableData = []; // 清空表格数据


            let arr = this.accountIds.split(/\s+/);

            try {
                // 循环发送请求
                for (const accountId of arr) {
                    const data = await this.fetchAccountData(this.token, accountId);
                    console.log(data);


                }
            } catch (error) {
                this.$message.error('查询失败：' + error.message);
            } finally {
                this.queryLoading = false;
            }
        },

        async fetchAccountData(cookie, accountId) {
            this.loading = true
            try {
                const res = await axios.get('https://control.zjwec.cn/creativeRecord/getByUserName', {
                    params: { keyword: accountId }
                });

                console.log(res.data);
                const batchSize = 30;  // 每批10条
                const delay = 1000;    // 每批间隔2秒

                const uniqueArray = res.data.reduce((acc, current) => {
                    // 检查是否已存在相同 adid 的对象
                    if (!acc.some(item => item.adid === current.adid)) {
                        acc.push(current);
                    }
                    return acc;
                }, []);

                console.log(uniqueArray);
                const promises = uniqueArray.map(item => {
                    const timestamp = Date.now().toString();
                    const nonce = Math.round(Math.random() * 1e11);
                    return axios.post(
                        `api/openapi/v1/ad/creative/pageInfo?access_token=${item.token}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${item.ids}`,
                        { advertisementIds: [item.adid] }
                    ).then(result => {
                        return result.data.data.list.map(items => ({
                            ...items,
                            idsname: item.idsname
                        }));
                    });
                })

                const responses = await Promise.all(promises);
                console.log(responses);
                const processItems = async () => {
                    for (const item of responses) {
                        console.log(item);
                        if (item.length > 0) {
                            for (const item2 of item) {
                                // console.log(item2);
                                try {
                                    // 3. 处理审核状态
                                    if (item2.auditState === 3 ||
                                        (item2.auditState === 1 && Date.now() - new Date(item2.createDate) > 7 * 864e5)) {
                                        console.log(item2.id);
                                        // console.log();
                                        // console.log(res.data);
                                        let del_id = res.data.filter(itemd => itemd.cyid == item2.id)
                                        console.log(del_id);
                                        // await axios.get(`https://control.zjwec.cn/creativeRecord/delete?id=${del_id[0].id}`);
                                        if (del_id.length > 0) { // 确保有匹配的元素
                                            await axios.get(`https://control.zjwec.cn/creativeRecord/delete?id=${del_id[0].id}`);
                                        } else {
                                            console.log('未找到匹配的记录，无法删除');
                                        }
                                    } else if (item2.auditState === 2) {  // 注意这里改为 item2
                                        // console.log(item.idsname);
                                        this.tableData = [...this.tableData, item2];
                                    }
                                } catch (error) {
                                    console.error('处理记录时出错:', error);
                                }
                            }
                        }
                    }
                };
                processItems().then(() => {
                    console.log('所有记录处理完成');
                    console.log(this.tableData);
                });


            } catch (error) {
                console.error("获取账户数据失败:", error);
                this.$message.error("数据加载失败！");
            } finally {
                this.loading = false
            }
        },


        validateQueryParams() {
            if (!this.token) {
                this.$message.error('请输入令牌值');
                return false;
            }
            if (this.getAccountIds().length === 0) {
                this.$message.error('请输入至少一个账户ID');
                return false;
            }
            return true;
        },

        getAccountIds() {
            return this.accountIds.split('\n')
                .map(id => id.trim())
                .filter(id => id);
        },

        async handleTransfer(type) {
            // if (!this.validateParams()) return;


            const accounts = this.selectedData;
            const requests = accounts.map(user =>
                this.sendTransferRequest({
                    accountId: user.uuid,
                    amount: this.amount,
                    type: type,
                    token: this.token
                })
            );

            try {
                await Promise.all(requests);
                this.$message.success('操作成功');
                this.handleQuery(); // 刷新数据
            } catch (error) {
                this.$message.error('部分操作失败');
            }
        },

        handleRowTransfer(row, type) {
            this.amount = type === 'OUT' ? row.cash : 0;
            this.accountIds = row.accountId;
            this.handleTransfer(type);
        },

        handleSortChange({ prop, order }) {
            this.sortProp = prop;
            this.sortOrder = order;
            // 这里可以调用后端排序接口或前端排序逻辑
        },

        async sendTransferRequest(params) {

            if (params.type === "IN") {
                return this.$axios.post('https://control.zjwec.cn/api/vivo/secondTransferIn', params);
            } else {
                return this.$axios.post('https://control.zjwec.cn/api/vivo/secondTransferOut', params);
            }

            // 实际接口调用

        }
    }
}
</script>
<style scoped>
/* 容器样式 */
.container {
    padding: 20px;
}

/* 操作区域卡片样式 */
.operation-card {
    margin-bottom: 20px;
}

/* 操作区域布局样式 */
.flex-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

/* 数据表格卡片样式 */
.data-card .el-table {
    margin-top: 20px;
}

/* 表格内链接样式 */
.data-card .el-table .el-link {
    margin: 0 5px;
}

/* 移动端适配 */
@media (max-width: 768px) {
    .flex-container {
        flex-direction: column;
        align-items: flex-start !important;
    }

    .flex-container>* {
        margin: 5px 0 !important;
        width: 100% !important;
    }

    .flex-container .el-divider--vertical {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/login/statusquery.vue